import React, { useEffect, useRef, useState } from 'react';
import "../../BREComponent/BRETable/BRETable.css";
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper
} from '@mui/material';
import sortingimg from "../../../Assets/sortingarrow.svg";
import eyebre from "../../../Assets/eyebre.svg";
import eyebreopened from "../../../Assets/eyebreopened.svg";
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import AttachMoneyOutlinedIcon from '@mui/icons-material/AttachMoneyOutlined';
import neweventslogo from "../../../Assets/neweventslogo.svg"
import moment from 'moment';
import LocationTableBRE from './LocationTableBRE';
import FinancialTable from './FinancialTable';
import NewsEventsBre from './NewsEventsBre';
import SouthIcon from '@mui/icons-material/South';
import NorthIcon from '@mui/icons-material/North';
import excellogo from "../../../Assets/excellogobre.svg";
import * as XLSX from "xlsx";
import { useNavigate } from 'react-router-dom';
function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const BRETable = ({ selectedOuterRows, setSelectedOuterRows, breTableData, breLocationData,
    setBreTableData, skip, setSkip, showLoadMore, downloadToPDF, setDownloadToPDF, setLoading,
    expandedRowId, setExpandedRowId, locationTableData, setLocationTableData, breFinancialData,
    financialTableData, setFinancialTableData, contentRef, value, setValue }) => {

    const [sortOrder, setSortOrder] = React.useState("");
    const [sortField, setSortField] = React.useState("org_date");
    const navigate = useNavigate()

    const handleToggledEye = (item) => {
        setExpandedRowId(prevId => (prevId?.bre_organization_id === item?.bre_organization_id ? null : item));
    };
    const handleToggledEyeClose = (item) => {
        setExpandedRowId(prevId => (prevId?.bre_organization_id === item?.bre_organization_id ? null : item));
        setLocationTableData({})
        setFinancialTableData({})
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };


    useEffect(() => {
        if (expandedRowId?.bre_organization_id) {
            breLocationData();
            breFinancialData();
        }
    }, [expandedRowId]);


    const handleRowSelect = (row) => {
        setSelectedOuterRows(prevSelectedRows => {
            const isAlreadySelected = prevSelectedRows.some(item => item.bre_organization_id === row.bre_organization_id);

            if (isAlreadySelected) {
                return prevSelectedRows.filter(item => item.bre_organization_id !== row.bre_organization_id);
            } else {
                return [...prevSelectedRows, row];
            }
        });

    };

    const handleSort = (field, sorting) => {
        let newSortOrder;
        if (sortField === field) {
            newSortOrder = sorting ? sorting : sortOrder === "asc" ? "desc" : "asc";
        } else {
            newSortOrder = sorting ? sorting : "asc";
        }
        setSortOrder(newSortOrder);
        setSortField(field);

        const employeeOrder = [
            "1-10", "11-50", "51-100", "101-250", "251-500", "501-1000",
            "1K-5K", "5K-10K", "10K+"
        ];

        const revenueOrder = [
            "$0-$1m", "$0-$1M", "$1m-$10m", "$1M-$10M", "$10m-$50m", "$10M-$50M", "$50m-$100m", "$50M-$100M",
            , "$100m-$500m", "$100M-$500M", "$500m-$1b", "$500M-$1B", "$1b-$10b", "$1B-$10B", "$10b+", "$10B+"
        ];

        const getOrderIndex = (value, orderArray) => {
            const index = orderArray.indexOf(value);
            return index !== -1 ? index : orderArray.length;
        };

        const sortedData = [...breTableData].sort((a, b) => {
            let aValue = field.includes(".")
                ? field.split(".").reduce((acc, key) => acc?.[key], a)
                : a[field];
            let bValue = field.includes(".")
                ? field.split(".").reduce((acc, key) => acc?.[key], b)
                : b[field];

            const isEmpty = (val) => val === null || val === "" || val === "-";
            const aIsEmpty = isEmpty(aValue);
            const bIsEmpty = isEmpty(bValue);

            if (aIsEmpty && !bIsEmpty) return 1;
            if (!aIsEmpty && bIsEmpty) return -1;
            if (aIsEmpty && bIsEmpty) return 0;

            if (field === "org_date") {
                aValue = new Date(aValue);
                bValue = new Date(bValue);
            }

            if (field === "org_num_employees") {
                return newSortOrder === "asc"
                    ? getOrderIndex(aValue, employeeOrder) - getOrderIndex(bValue, employeeOrder)
                    : getOrderIndex(bValue, employeeOrder) - getOrderIndex(aValue, employeeOrder);
            }

            if (field === "org_revenue_range") {
                return newSortOrder === "asc"
                    ? getOrderIndex(aValue, revenueOrder) - getOrderIndex(bValue, revenueOrder)
                    : getOrderIndex(bValue, revenueOrder) - getOrderIndex(aValue, revenueOrder);
            }

            if (typeof aValue === "number" && typeof bValue === "number") {
                return newSortOrder === "asc" ? aValue - bValue : bValue - aValue;
            }

            if (typeof aValue === "string" && typeof bValue === "string") {
                return newSortOrder === "asc"
                    ? aValue.localeCompare(bValue)
                    : bValue.localeCompare(aValue);
            }

            if (aValue instanceof Date && bValue instanceof Date) {
                return newSortOrder === "asc" ? aValue - bValue : bValue - aValue;
            }

            return 0;
        });
        setBreTableData(sortedData);
    };
    // React.useEffect(() => {
    //     if (breTableData?.length) {
    //         handleSort("org_date", 'desc')
    //     }
    // }, [breTableData?.length])
    const exportToExcel = () => {
        const { balance_sheet_details, ...otherData } = financialTableData;

        if (!balance_sheet_details) {
            console.error("No balance sheet details found.");
            return;
        }
        const formatKey = (key) => {
            if (!key) return '';
            return key
                .replace(/_/g, ' ')
                .replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
        };
        const formatValue = (val) => {
            if (typeof val === 'number') {
                return `$${val.toLocaleString()}`;
            }
            return val ?? '';
        };

        const breKeys = Object.keys(otherData);
        const balanceKeys = Object.keys(balance_sheet_details);
        const maxLength = Math.max(breKeys.length, balanceKeys.length);

        const rows = [];

        for (let i = 0; i < maxLength; i++) {
            rows.push({
                "Financial Data": formatKey(breKeys[i]),
                "Financial Values": breKeys[i] ? formatValue(otherData[breKeys[i]]) : '',
                "Balance Sheet Details": formatKey(balanceKeys[i]),
                "Balance Sheet Values": balanceKeys[i] ? formatValue(balance_sheet_details[balanceKeys[i]]) : '',
            });
        }

        const ws = XLSX.utils.json_to_sheet(rows);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Formatted Financial Data");

        const filename = `${otherData.company_name?.replace(/[^a-zA-Z0-9]/g, '_')}_FormattedFinancialData`;
        XLSX.writeFile(wb, `${filename}.xlsx`);
    };

    return (
        <>

            <TableContainer component={Paper} className='bre-tc-outer' ref={contentRef}>
                <Table>
                    <TableHead>
                        <TableRow style={{ width: '100%' }}>
                            <TableCell style={{ width: '6%' }}><p className='bre-table-th'> Select</p></TableCell>
                            <TableCell style={{ width: '22%' }}><p className='bre-table-th'>Company
                                {sortField === "account_name" ? (
                                    sortOrder === "asc" ? (
                                        <NorthIcon
                                            style={{ fontSize: "10px", cursor: "pointer" }}
                                            onClick={() => handleSort("account_name")}
                                        />
                                    ) : (
                                        <SouthIcon
                                            style={{ fontSize: "10px", cursor: "pointer" }}
                                            onClick={() => handleSort("account_name")}
                                        />
                                    )
                                ) : (
                                    <img
                                        src={sortingimg}
                                        alt=""
                                        onClick={() => handleSort("account_name")}
                                        className="sorting-arrow-leadsprofile"
                                    />
                                )}</p></TableCell>
                            <TableCell style={{ width: '18%' }}><p className='bre-table-th'>JO Sector
                                {sortField === "org_industry" ? (
                                    sortOrder === "asc" ? (
                                        <NorthIcon
                                            style={{ fontSize: "10px", cursor: "pointer" }}
                                            onClick={() => handleSort("org_industry")}
                                        />
                                    ) : (
                                        <SouthIcon
                                            style={{ fontSize: "10px", cursor: "pointer" }}
                                            onClick={() => handleSort("org_industry")}
                                        />
                                    )
                                ) : (
                                    <img
                                        src={sortingimg}
                                        alt=""
                                        onClick={() => handleSort("org_industry")}
                                        className="sorting-arrow-leadsprofile"
                                    />
                                )}</p></TableCell>
                            <TableCell style={{ width: '15%' }}><p className='bre-table-th'>Employment
                                {sortField === "org_num_employees" ? (
                                    sortOrder === "asc" ? (
                                        <NorthIcon
                                            style={{ fontSize: "10px", cursor: "pointer" }}
                                            onClick={() => handleSort("org_num_employees")}
                                        />
                                    ) : (
                                        <SouthIcon
                                            style={{ fontSize: "10px", cursor: "pointer" }}
                                            onClick={() => handleSort("org_num_employees")}
                                        />
                                    )
                                ) : (
                                    <img
                                        src={sortingimg}
                                        alt=""
                                        onClick={() => handleSort("org_num_employees")}
                                        className="sorting-arrow-leadsprofile"
                                    />
                                )}</p></TableCell>
                            <TableCell style={{ width: '10%' }}><p className='bre-table-th'>Revenue
                                {sortField === "org_revenue_range" ? (
                                    sortOrder === "asc" ? (
                                        <NorthIcon
                                            style={{ fontSize: "10px", cursor: "pointer" }}
                                            onClick={() => handleSort("org_revenue_range")}
                                        />
                                    ) : (
                                        <SouthIcon
                                            style={{ fontSize: "10px", cursor: "pointer" }}
                                            onClick={() => handleSort("org_revenue_range")}
                                        />
                                    )
                                ) : (
                                    <img
                                        src={sortingimg}
                                        alt=""
                                        onClick={() => handleSort("org_revenue_range")}
                                        className="sorting-arrow-leadsprofile"
                                    />
                                )}</p></TableCell>
                            <TableCell style={{ width: '20%' }}><p className='bre-table-th'>Last Recorded BRE
                                {sortField === "org_date" ? (
                                    sortOrder === "asc" ? (
                                        <NorthIcon
                                            style={{ fontSize: "10px", cursor: "pointer" }}
                                            onClick={() => handleSort("org_date")}
                                        />
                                    ) : (
                                        <SouthIcon
                                            style={{ fontSize: "10px", cursor: "pointer" }}
                                            onClick={() => handleSort("org_date")}
                                        />
                                    )
                                ) : (
                                    <img
                                        src={sortingimg}
                                        alt=""
                                        onClick={() => handleSort("org_date")}
                                        className="sorting-arrow-leadsprofile"
                                    />
                                )}</p></TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    {
                        expandedRowId?.bre_organization_id ?
                            <TableBody>
                                <React.Fragment>
                                    <TableRow>
                                        <TableCell><p className='bre-table-tr'>
                                            <input type="checkbox" style={{ cursor: 'pointer' }} onChange={() => handleRowSelect(expandedRowId)}
                                                checked={selectedOuterRows.some(item => item.bre_organization_id === expandedRowId?.bre_organization_id)} />
                                        </p></TableCell>
                                        <TableCell><p className='bre-table-tr' style={{ cursor: 'pointer' }} onClick={() => navigate(`/companyprofilescreen/${expandedRowId?.org_id}/0`)}>{expandedRowId?.account_name}</p></TableCell>
                                        <TableCell><p className='bre-table-tr'>{expandedRowId?.org_industry}</p></TableCell>
                                        <TableCell><p className='bre-table-tr'>{expandedRowId?.org_num_employees}</p></TableCell>
                                        <TableCell><p className='bre-table-tr'>{expandedRowId?.org_revenue_range}</p></TableCell>
                                        <TableCell><p className='bre-table-tr'>{moment(expandedRowId?.org_date).format('MM/DD/YYYY')}<br /> {expandedRowId?.last_recorded_bre}</p></TableCell>
                                        <TableCell onClick={() => handleToggledEyeClose(expandedRowId)} style={{ textAlign: '-webkit-right' }}>
                                            <p className='bre-table-tr-eye'>
                                                <img src={eyebreopened} alt="eye-icon" />
                                            </p>
                                        </TableCell>
                                    </TableRow>

                                    <TableRow className='trow-BRE-tabs'>
                                        <TableCell colSpan={7} style={{ padding: 0 }}>
                                            <Box sx={{ width: '100%', backgroundColor: '#f9f9f9' }}>
                                                {
                                                    expandedRowId?.bre_organization_id && downloadToPDF === true ?
                                                        <>
                                                            <>
                                                                <Box sx={{ borderBottom: 1, borderColor: 'divider' }} style={{ pageBreakInside: "avoid", display: "flex", flexDirection: "column", alignItems: "start" }}>
                                                                    <Tabs value={value} onChange={handleChange} aria-label="BRE detail tabs">
                                                                        <Tab
                                                                            label={
                                                                                <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                                                    <LocationOnOutlinedIcon fontSize="small" />
                                                                                    Locations
                                                                                </span>
                                                                            }
                                                                            {...a11yProps(0)}
                                                                        />
                                                                    </Tabs>
                                                                </Box>
                                                                <div ><LocationTableBRE locationTableData={locationTableData} /></div>
                                                            </>
                                                            <>
                                                                <Box sx={{ borderBottom: 1, borderColor: 'divider' }} style={{ pageBreakInside: "avoid", breakBefore: 'page', display: "flex", flexDirection: "column", alignItems: "start" }}>
                                                                    <Tabs value={value} onChange={handleChange} aria-label="BRE detail tabs">

                                                                        <Tab
                                                                            label={
                                                                                <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                                                    <AttachMoneyOutlinedIcon fontSize="small" />
                                                                                    Financial Metrics
                                                                                </span>
                                                                            }
                                                                            {...a11yProps(1)}
                                                                        />

                                                                    </Tabs>
                                                                </Box>
                                                                <FinancialTable financialTableData={financialTableData} downloadToPDF={downloadToPDF} />
                                                            </>
                                                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }} style={{ pageBreakInside: "avoid", breakBefore: 'page', display: "flex", flexDirection: "column", alignItems: "start" }}>
                                                                <Tabs value={value} onChange={handleChange} aria-label="BRE detail tabs">
                                                                    <Tab
                                                                        label={
                                                                            <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                                                <img src={neweventslogo} alt="" />
                                                                                News/Events
                                                                            </span>
                                                                        }
                                                                        {...a11yProps(2)}
                                                                    />
                                                                </Tabs>
                                                                <NewsEventsBre expandedRowId={expandedRowId} downloadToPDF={downloadToPDF} />
                                                            </Box>
                                                        </> :
                                                        <>
                                                            <Box sx={{ borderBottom: 1, borderColor: 'divider', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'relative' }}>
                                                                <Tabs value={value} onChange={handleChange} aria-label="BRE detail tabs">
                                                                    <Tab
                                                                        label={
                                                                            <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                                                <LocationOnOutlinedIcon fontSize="small" />
                                                                                Locations
                                                                            </span>
                                                                        }
                                                                        {...a11yProps(0)}
                                                                    />
                                                                    <Tab
                                                                        label={
                                                                            <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                                                <AttachMoneyOutlinedIcon fontSize="small" />
                                                                                Financial Metrics
                                                                            </span>
                                                                        }
                                                                        {...a11yProps(1)}
                                                                    />
                                                                    <Tab
                                                                        label={
                                                                            <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                                                <img src={neweventslogo} alt="" />
                                                                                News/Events
                                                                            </span>
                                                                        }
                                                                        {...a11yProps(2)}
                                                                    />
                                                                </Tabs>
                                                                <div className='excellogo-bre-main'>   <img src={excellogo} alt="Export to Excel" style={{ cursor: 'pointer' }} onClick={exportToExcel} /></div>
                                                            </Box>
                                                            <CustomTabPanel value={value} index={0} className='cp-LocationTableBRE'>
                                                                <div ><LocationTableBRE locationTableData={locationTableData} /></div>
                                                            </CustomTabPanel>
                                                            <CustomTabPanel value={value} index={1}>
                                                                <FinancialTable financialTableData={financialTableData} />
                                                            </CustomTabPanel>

                                                            <CustomTabPanel value={value} index={2}>
                                                                <NewsEventsBre expandedRowId={expandedRowId} />
                                                            </CustomTabPanel>
                                                        </>
                                                }

                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                </React.Fragment>

                            </TableBody>
                            :
                            <>
                                <TableBody>
                                    {breTableData.map((item) => (
                                        <React.Fragment key={item.id}>
                                            <TableRow>
                                                <TableCell><p className='bre-table-tr'><input style={{ cursor: 'pointer' }} type="checkbox" onChange={() => handleRowSelect(item)}
                                                    checked={selectedOuterRows.some(i => i.bre_organization_id === item?.bre_organization_id)} /></p></TableCell>
                                                <TableCell><p className='bre-table-tr' style={{ cursor: 'pointer' }} onClick={() => navigate(`/companyprofilescreen/${item?.org_id}/0`)}>{item?.account_name ? item?.account_name : "-"}</p></TableCell>
                                                <TableCell><p className='bre-table-tr'>{item?.org_industry ? item?.org_industry : "-"}</p></TableCell>
                                                <TableCell><p className='bre-table-tr'>{item?.org_num_employees ? item?.org_num_employees : "-"}</p></TableCell>
                                                <TableCell><p className='bre-table-tr'>{item?.org_revenue_range ? item?.org_revenue_range : "-"}</p></TableCell>
                                                <TableCell><p className='bre-table-tr'>{moment(item?.org_date).format('MM/DD/YYYY')}<br /> {item?.last_recorded_bre}</p></TableCell>
                                                <TableCell onClick={() => handleToggledEye(item)}>
                                                    <p className='bre-table-tr-eye'>
                                                        <img src={eyebre} alt="eye-icon" />
                                                    </p>
                                                </TableCell>
                                            </TableRow>
                                        </React.Fragment>
                                    ))}
                                </TableBody>
                            </>
                    }
                </Table>
                {
                    expandedRowId?.bre_organization_id ? null :
                        <div className="loadmore-pagination-section">
                            {(skip * 50) < breTableData?.length && showLoadMore ? <button className="btn-load-more button-loadmore-pagination crie-load-more" onClick={() => setSkip((prev) => prev + 1)} >Load More</button> : null}
                        </div>
                }
            </TableContainer>

        </>
    );
};

export default BRETable;